/**
 * Modals
 */

import { merge, assign } from 'lodash';

// Strategies - implements Strategy design pattern
import ConfigStrategyManager from '@/components/media/select/strategy/ConfigStrategyManager';
import ChangeThumbnail from '@/components/media/select/strategy/ChangeThumbnail';
import ChangeSetThumbnail from '@/components/media/select/strategy/ChangeSetThumbnail';
import UploadNewVersion from '@/components/media/select/strategy/UploadNewVersion';
import AddItemsToSet from '@/components/media/select/strategy/AddItemsToSet';
import AddSetToSet from '@/components/media/select/strategy/AddSetToSet';
import AddItemsToExistingSet from '@/components/media/select/strategy/AddItemsToExistingSet';
import BeforeAfter from '@/components/media/select/strategy/BeforeAfter';
import AddToMarkup from '@/components/media/select/strategy/AddToMarkup';
import SelectMedia from '@/components/media/select/strategy/SelectMedia';
import MoveSet from '@/components/media/select/strategy/MoveSet';
import MoveToSet from '@/components/media/select/strategy/MoveToSet';

const strategies = {
    ChangeThumbnail,
    ChangeSetThumbnail,
    UploadNewVersion,
    AddItemsToSet,
    AddSetToSet,
    AddItemsToExistingSet,
    BeforeAfter,
    AddToMarkup,
    SelectMedia,
    MoveSet,
    MoveToSet,
};
const StrategyManager = new ConfigStrategyManager();

// state
export const modalState = {
    deletemodal: {
        show: false,
        items: null,
    },
    hiresmodal: {
        show: false,
        item: null,
    },
    selectmodal: {
        show: false,
        currentView: 'MediaSelect',
        loadingMessage: '',
    },
};

// mutations
export const modalMutations = {
    /**
     * Sets wether to show the media delete modal
     * TODO: check if this is still used anywhere, we are now uisng ca.confirm
     * @param {boolean} show
     */
    setMediaDeleteModalShow(state, show) {
        state.deletemodal.show = show;
    },

    /**
     * Sets media select modals media itens
     * @param {array} items - Media
     */
    setMediaDeleteModalItems(state, items) {
        state.deletemodal.items = items;
    },

    /**
     * Sets wether to show the media hires request modal
     * @param {boolean} show
     */
    setMediaHiresModalShow(state, show) {
        state.hiresmodal.show = show;
    },

    /**
     * Sets the media item used in the hires request modal
     * @param {boolean} show
     */
    setMediaHiresModalItem(state, item) {
        state.hiresmodal.item = item;
    },

    /**
     * Sets wether to show the media select modal
     * @param {boolean} show
     */
    setMediaSelectModalShow(state, show) {
        state.selectmodal.show = show;
    },

    /**
     * Sets the intial view of the media select modal
     * @param {string} view - component name MediaSelect|MediaUpload
     */
    setMediaSelectModalCurrentView(state, view) {
        state.selectmodal.currentView = view;
    },

    /**
     * Sets the loading message for the media select modal
     * @param {string} msg
     */
    setMediaSelectLoadingMessage(state, msg) {
        state.selectmodal.loadingMessage = msg;
    },
};

// getters
export const modalGetters = {
    /**
     * Gets wether media delete modal is currently visible
     * TODO: check if this is still used any where, we have ca.confirm now
     * @returns {boolean}
     */
    getMediaDeleteModalShow(state) {
        return state.deletemodal.show;
    },

    /**
     * Gets media delete modals media items to delete
     * @returns {array} - Media
     */
    getMediaDeleteModalItems(state) {
        return state.deletemodal.items;
    },

    /**
     * Gets wether hires modal is currently visible
     * @returns {boolean}
     */
    getMediaHiresModalShow(state) {
        return state.hiresmodal.show;
    },

    /**
     * Gets hires modal media item
     * @returns {object} - Media
     */
    getMediaHiresModalItem(state) {
        return state.hiresmodal.item;
    },

    /**
     * Gets wether media select modal is currently visible
     * @returns {boolean}
     */
    getMediaSelectModalShow(state) {
        return state.selectmodal.show;
    },

    /**
     * Gets media select modal current view component name
     * @returns {string} - MediaSelect|MediaUpload
     */
    getMediaSelectModalCurrentView(state) {
        return state.selectmodal.currentView;
    },

    /**
     * Gets media select modal loading message
     * @returns {string}
     */
    getMediaSelectLoadingMessage(state) {
        return state.selectmodal.loadingMessage;
    },
};

// actions
export const modalActions = {
    /**
     * Shows the media select modal, configures to passed / strategy options
     * @param {object} options
     * @see https://github.com/spatialmedia/cms/wiki/MediaSelectModal
     * @return {object} Promise
     */
    showMediaSelectModal({ commit, state }, options) {
        // set strategy options
        if (options.strategy) {
            const strategy = new strategies[options.strategy]();
            StrategyManager.strategy = strategy;
            const config = StrategyManager.config();
            // Don't merge filters replace them
            if (options.filters) {
                config.filters = assign({}, config.filters, options.filters);
            }
            options = merge({}, config, options);
            commit('setMediaSelectStrategyManager', StrategyManager);
            commit('setMediaSelectStrategy', config);

            // Set initial view if strategy has one set
            if (options.initialView) {
                commit('setMediaSelectModalCurrentView', options.initialView);
            }
            // set upload options if strategy has options present
            if (options.upload) {
                commit('setMediaUploadModalOptions', merge({}, state.uploadmodal.options, options.upload));
            }
        }
        commit('setMediaSelectOptions', merge({}, state.select.options, options));
        commit('setMediaSelectModalShow', true);

        console.log('MediaSelectOptions', state.select.options);
    },
    /**
     * Hides the media select modal
     * TODO: use defaultState
     * @return {object} Promise
     */
    hideMediaSelectModal({ commit, dispatch, getters }) {
        commit('setMediaSelectModalShow', false);
        commit('setMediaSelectModalCurrentView', 'MediaSelect');
        commit('setMediaSelectLoadingMessage', '');
        dispatch('resetMediaSelect');
        dispatch('resetMediaUploadModal');
    },
};
